// ================================================================
// Scenarios API client — هر شرکت یک سناریو دارد.
// ================================================================
import { apiRequest } from './apiClient.js';

// سناریوی یک شرکت را بگیر (در نبود، backend خودش یکی می‌سازد)
export function getCompanyScenario(organizationId) {
  const q = organizationId ? '?organizationId=' + encodeURIComponent(organizationId) : '';
  return apiRequest('/api/scenarios' + q);
}

// ذخیره‌ی canvas (و در صورت نیاز نام/فعال‌سازی) برای یک سناریو
export function saveScenario(id, organizationId, patch) {
  return apiRequest('/api/scenarios/' + encodeURIComponent(id), {
    method: 'PUT',
    body: JSON.stringify({ organizationId, ...patch }),
  });
}
